import { render, staticRenderFns } from "./Tx.vue?vue&type=template&id=48e82e3e&scoped=true"
import script from "./Tx.vue?vue&type=script&lang=js"
export * from "./Tx.vue?vue&type=script&lang=js"
import style0 from "./Tx.vue?vue&type=style&index=0&id=48e82e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e82e3e",
  null
  
)

export default component.exports